export default {
    pagenumber: ["Current", "Page", "Together", "Page"],
    prev: "previous page",
    next: "next page",
    error: "Failed to load the file",
    openInNewWindow: "Open in New Window",
    continuousMode: "Continuous",
    paginatedMode: "Paginated",
};
